"use client";

import React from "react";
import type { IIpoListAPIResponse } from "../../interfaces/IpoList.interface";
import IpoListWrapper from "../IpoList/IpoListWrapper";
import { IpoAuthoringDataType } from "../IpoBase/IpoBaseAuthoringType";

type ClosedIpoClientProps = {
  mainboardInitial: IIpoListAPIResponse;
  smeInitial: IIpoListAPIResponse;
  authoringData?: IpoAuthoringDataType;
};

const CLOSED_IPO_DEFAULTS: Required<
  Omit<
    IpoAuthoringDataType,
    | "signInText"
    | "redirectToPdpBaseUrl"
    | "viewAllRedirectUrl"
    | "headingLevel"
  >
> = {
  componentLink: "closed-ipo",
  ipoTitle: "Closed IPO",
  mainboardTitle: "Mainboard",
  smeTitle: "SME",
  viewAllText: "View all",
  biddingPeriodText: "Bidding period",
  minimumInvestmentText: "Minimum investment",
  bidPriceText: "Issue price",
  listingDateText: "Listing date",
  listingGainText: "Listing gain",
  pageType: "closed-ipo",
  showMoreCtaText: "Show more",
  paginationLimit: "20",
  ipoType: "closed",
  apiErrorDesc: "No closed IPOs found.",
  fetchApiDataErrorDesc: "Unable to fetch closed IPOs right now.",
  tbaText: "TBA",
  openInNewTab: "false",
};

const ClosedIpoClient = ({
  mainboardInitial,
  smeInitial,
  authoringData,
}: ClosedIpoClientProps) => {
  const mergedAuthoringData = {
    ...CLOSED_IPO_DEFAULTS,
    ...authoringData,
  };

  return (
    <IpoListWrapper
      componentLink={mergedAuthoringData.componentLink}
      ipoTitle={mergedAuthoringData.ipoTitle}
      mainboardTitle={mergedAuthoringData.mainboardTitle}
      smeTitle={mergedAuthoringData.smeTitle}
      viewAllText={mergedAuthoringData.viewAllText}
      biddingPeriodText={mergedAuthoringData.biddingPeriodText}
      minimumInvestmentText={mergedAuthoringData.minimumInvestmentText}
      bidPriceText={mergedAuthoringData.bidPriceText}
      listingDateText={mergedAuthoringData.listingDateText}
      listingGainText={mergedAuthoringData.listingGainText}
      pageType={mergedAuthoringData.pageType}
      showMoreCtaText={mergedAuthoringData.showMoreCtaText}
      paginationLimit={mergedAuthoringData.paginationLimit}
      ipoType={mergedAuthoringData.ipoType}
      apiErrorDesc={mergedAuthoringData.apiErrorDesc}
      fetchApiDataErrorDesc={mergedAuthoringData.fetchApiDataErrorDesc}
      tbaText={mergedAuthoringData.tbaText}
      signInText={authoringData?.signInText}
      redirectToPdpBaseUrl={authoringData?.redirectToPdpBaseUrl}
      viewAllRedirectUrl={authoringData?.viewAllRedirectUrl}
      openInNewTab={mergedAuthoringData.openInNewTab}
      mainboardInitial={mainboardInitial}
      smeInitial={smeInitial}
    />
  );
};

export default ClosedIpoClient;
